import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Avatar, ListItemIcon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { routes, getRoleDisplayLabel } from '../../config/utility';
import {
  Logout as LogoutIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import logo from "../../assets/favicon.svg";
import NotificationBell from '../notifications/NotificationBell';

const Headerbar = ({ user, roles, isSidebarOpen, setShowLogoutModal }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const roleLabel = getRoleDisplayLabel(roles);

  // Handle profile menu
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const logoutHandle = () => {
    setAnchorEl(null);
    setShowLogoutModal(true)
  };

  // Navigate to Profile Page
  const handleProfileClick = () => {
    handleProfileMenuClose();
    if (user && user.username) {
      const profileUrl = routes.profile.replace(':username?', user.username);
      navigate(profileUrl);
    } else {
      console.warn("User data is not available.");
    }
  };

  return (
    // <div className="bg-transparent w-full h-20 flex items-center justify-between px-8 mb-1 mt-4">
    <div className={`bg-transparent backdrop-blur-lg w-full fixed top-0 sm:ml-4 z-30  py-2 sm:py-2 h-16
      flex items-center sm:justify-between sm:px-4 transition-all  ${isSidebarOpen ? ' sm:w-[calc(100%-16rem)]' : ' sm:w-[calc(100%-4rem)]'}`}>


      {/* Left Section: Logo - Hidden on mobile, visible on SM and up */}
      <div className="hidden sm:flex items-center space-x-1 ">
        <img src={logo} alt="Pawdash Logo" className="h-10" />
      </div>

      {/* Center Logo - Visible only on mobile */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 sm:hidden">
        <img src={logo} alt="Pawdash Logo" className="h-8" />
      </div>

      {/* Search Bar */}
      {/* {roles.includes('admin') && (
        <div className="flex-grow mx-12 relative max-w-4xl hidden sm:block">
          <input
            type="text"
            placeholder="Search"
            className="w-full py-4 px-6 rounded-full bg-white focus:outline-none focus:ring-2 focus:ring-indigo-400 shadow-md text-gray-600 placeholder-gray-400 transition"
          />
          <SearchIcon className="absolute top-4 right-6 text-gray-400" />
        </div>
      )} */}

      {/* Right Section: Profile */}
      <div className="absolute top-1 sm:top-0 right-1 sm:right-4 sm:relative flex items-center gap-2">
        {roleLabel && (
          <span className="hidden sm:inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-primary/10 text-primary border border-primary/20">
            {roleLabel}
          </span>
        )}
        <NotificationBell roles={roles} />

        {/* Profile Section */}
        <div className="relative">
          <div>
            <IconButton
              onClick={handleProfileMenuOpen}
              className="relative sm:p-3 bg-[#1C1F2A] text-dark rounded-full hover:bg-[#2C2F3F] transition-all duration-300"
            >
              <Avatar
                alt={user?.name || 'User Avatar'}
                src={user?.profile_photo || '/assets/default-avatar.png'}
                className="w-8 h-8 sm:w-10 sm:h-10 border border-[#374151]"
              />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleProfileMenuClose}
              PaperProps={{
                style: {
                  width: '270px',
                  borderRadius: '1.5rem', // rounded-2xl
                  background: '#fff', // light theme
                  border: '1px solid #E5E7EB', // soft border
                  boxShadow: '0 8px 32px 0 #9B5DE522', // subtle purple shadow
                  padding: 0,
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <div className="p-5 bg-white border-b border-ash rounded-t-2xl">
                <h4 className="text-lg font-bold text-primary">{user?.name || 'User Name'}</h4>
                <p className="text-xs text-grey">{user?.email || 'user@example.com'}</p>
              </div>

              <MenuItem
                onClick={handleProfileClick}
                className="py-3 px-5 text-dark hover:bg-primary/10 hover:text-primary transition-all duration-200"
              >
                <ListItemIcon>
                  <PersonIcon className="text-primary" />
                </ListItemIcon>
                <span className="ml-2">Profile</span>
              </MenuItem>

              <MenuItem
                onClick={logoutHandle}
                className="py-3 px-5 text-dark hover:bg-secondary/10 hover:text-secondary transition-all duration-200 rounded-b-2xl"
              >
                <ListItemIcon>
                  <LogoutIcon className="text-secondary" />
                </ListItemIcon>
                <span className="ml-2">Logout</span>
              </MenuItem>
            </Menu>
          </div>
        </div>

        {/* Language Selector */}
        {/* <div className="relative">
          <select
            className="py-2 px-4 bg-gradient-to-br from-light to-ash hover:text-light text-dark font-semibold rounded-full shadow-md hover:shadow-primary focus:outline-none transition-transform transform hover:scale-105"
            defaultValue="English"
          >
            <option value="English">🇬🇧 English</option>
            <option value="Arabic">🇦🇪 Arabic</option>
          </select>
        </div> */}
      </div>


    </div>
  );
};

export default Headerbar;